import dl1 from "./assets/dl1.jpeg";
import dl2 from "./assets/dl2.jpeg";
import dl3 from "./assets/dl3.jpeg";
import dl4 from "./assets/dl4.jpeg";
import dl5 from "./assets/dl5.jpeg";
import bestResearchPrototype from "./assets/bestresearch&prototype.png";
import certpresentation from "./assets/certpresentation.png";
import active from "./assets/active.jpeg";
import mostactive from "./assets/mostactive.jpeg";
import certcompletion from "./assets/certcompletion.jpeg";
import runner3 from "./assets/3rdrunner.jpeg";
import sportswear from "./assets/sportswear.jpeg";
import msface from "./assets/msface.jpeg";
import sackrace from "./assets/sackrace.jpeg";
import committee from "./assets/committee.jpeg";
import digteam from "./assets/digteam.jpeg";
import cidrcon from "./assets/cidrcon.jpeg";

/** Keys match filenames (without extension) from your asset naming. */
export const EVIDENCE_IMAGES = {
    dl1,
    dl2,
    dl3,
    dl4,
    dl5,
    bestresearch_prototype: bestResearchPrototype,
    certpresentation,
    active,
    mostactive,
    certcompletion,
    "3rdrunner": runner3,
    sportswear,
    msface,
    sackrace,
    committee,
    digteam,
    cidrcon,
};

export function resolveEvidenceSources(keys) {
    if (!keys || !keys.length) return [];
    return keys.map((k) => EVIDENCE_IMAGES[k]).filter(Boolean);
}
